<template>
  <schoolRoutesDriversForm :typeEndPoint="'schoolRoutesDriversShow'" :dataParams="this.$route.params" />
</template>
<script>
import schoolRoutesDriversForm from '@/components/modules/schoolroutes/drivers/form'
export default {
  name: 'schoolRoutesDriversFormEdit',
  components: {
    schoolRoutesDriversForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/schoolroutes/drivers/edit.vue